module.exports = __webpack_public_path__ + "ec4a7df001abe004ab1bbdc950bc6a2d.png";